import { createContext, ReactNode, useContext, useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Product, SearchResult } from '../pages/Caisse/Interfaces';

// @ts-ignore
import Cookies from 'js-cookie';

interface AuthContextType {
    user: any | null;
    order: SearchResult | null;
    changeOrder: (order: any) => void;
    Products: Product[] | null;
    changeProduct: (order: any) => void;
    login: (user: any) => void;
    logout: () => void;
    newTabDetected: boolean;
    changeState: (state: boolean) => void;
    RefProduct: string;
    setRefProduct: (ref: string) => void;
    setLoading: (ref: boolean) => void;
    Loading: boolean;
    brands: { [key: string]: number | string };
    setBrands: (brands: { [key: string]: number | string }) => void;
    allowedInterfaces: string[];
    setAllowedInterfaces: (interfaces: string[]) => void
    interfacesLoaded: boolean;         
    setInterfacesLoaded: (state: boolean) => void;
    selectedBrands: string[];
    setSelectedBrands: React.Dispatch<React.SetStateAction<string[]>>;
}

export interface Paiements {
    total: number;
    paiements: any[];
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = (): AuthContextType => {
    const context = useContext(AuthContext);
    if (!context) throw new Error('useAuth must be used within AuthProvider');
    return context;
};

interface Props {
    children: ReactNode;
}

const AuthProvider: React.FC<Props> = ({ children }) => {
    const dispatch = useDispatch();

    const [user, setUser] = useState<any>(
        sessionStorage.getItem('authUser') ? JSON.parse(sessionStorage.getItem('authUser')!) : null
    );

    const [allowedInterfaces, setAllowedInterfaces] = useState<string[]>([]);
    const [order, setOrder] = useState<SearchResult | null>(null);
    const [Products, setProducts] = useState<Product[]>([]);
    const [RefProduct, setRefProduct] = useState<string>("");
    const [brands, setBrands] = useState<{ [key: string]: number | string }>({});
    const [newTabDetected, setNewTabDetected] = useState(false);
    const [Loading, setLoading] = useState(false);
    const inactivityTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const[interfacesLoaded, setInterfacesLoaded] = useState(false);
    const [selectedBrands, setSelectedBrands] = useState<string[]>([]);

    const INACTIVITY_LIMIT = 15 * 60 * 1000;

    const changeState = (newState: boolean) => {
        setNewTabDetected(newState);
    };

    const login = (userData: any) => {
        setUser(userData);
        sessionStorage.setItem('authUser', JSON.stringify(userData));
    };

    const changeOrder = (newOrder: any) => {
        setOrder(newOrder);
    };

    const changeProduct = (newProduct: any) => {
        setProducts(newProduct);
    };

    const logout = () => {
        setUser(null);
        sessionStorage.removeItem('authUser'); localStorage.removeItem('cart')
        changeOrder(null);
    };

    const resetInactivityTimer = () => {
        if (inactivityTimeoutRef.current) {
            clearTimeout(inactivityTimeoutRef.current);
        }
        inactivityTimeoutRef.current = setTimeout(() => {
            if (user) {
                logout();
            }
        }, INACTIVITY_LIMIT);
    };

    const handleActivity = () => {
        resetInactivityTimer();
    };

    useEffect(() => {
        if (user) {
            resetInactivityTimer();
            const events = ['mousemove', 'mousedown', 'click', 'keydown'];
            events.forEach((event) => {
                window.addEventListener(event, handleActivity);
            });

            return () => {
                events.forEach((event) => {
                    window.removeEventListener(event, handleActivity);
                });
                if (inactivityTimeoutRef.current) {
                    clearTimeout(inactivityTimeoutRef.current);
                }
            };
        }
    }, [user]);

    // Initialize from cookies on mount
    useEffect(() => {
        const raw = Cookies.get('allowedInterfaces');
        debugger
        if (raw) {
            try {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed) && parsed.every(item => typeof item === 'string')) {
                    debugger
                    // Filtrer le tableau pour enlever "caisse" si la permission est manquante
                    const filteredInterfaces = parsed.filter(item => {
                        if (item === 'caisse') {
                            return user?.perms?.facture?.paiement != null;
                        } else if (item === 'stock') {
                            return user?.perms?.stock?.mouvement?.creer != null;
                        } else if (item === 'vendeur') {
                            return user?.perms?.commande?.creer != null;
                        } else if (item === 'commandes') {
                            return user?.perms?.commande?.creer != null;
                        } else if (item === 'pickups') {
                            return user?.perms?.fournisseur?.commande?.receptionner == null || user?.perms?.expedition?.delivery != null
                            }

                        return true; // Garder tous les autres items
                    });

                    setAllowedInterfaces(filteredInterfaces);
                }
            } catch (err) {
                console.error(err);
            }
        }
        setInterfacesLoaded(true); // ✅ done loading
    }, []);


    return (
        <AuthContext.Provider
            value={{
                user,
                order,
                Products,
                changeProduct,
                login,
                logout,
                newTabDetected,
                changeState,
                changeOrder,
                RefProduct,
                setRefProduct,
                Loading,
                setLoading,
                setBrands,
                brands,
                allowedInterfaces,
                setAllowedInterfaces,
                interfacesLoaded,
                setInterfacesLoaded,
                selectedBrands, // Add this
                setSelectedBrands, // Add this

            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;
